import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let selectedLocations = useDataValue({
    context: 'tab',
    path: 'selected.locations',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_ids: selectedLocations,
    },
    // requestPolicy: 'network-only',
  }
}
